export default function PageHeader({ title, subtitle, icon, children }) {
  return (
    <div className="page-header">
      <div className="d-flex align-items-center gap-3">
        {icon ? (
          <span className="page-header-icon">
            <i className={`bi ${icon}`} />
          </span>
        ) : null}
        <div>
          <h1 className="page-header-title">{title}</h1>
          {subtitle ? <div className="page-header-subtitle">{subtitle}</div> : null}
        </div>
      </div>
      {children ? <div className="d-flex flex-wrap align-items-center gap-2">{children}</div> : null}
    </div>
  );
}
